import { ytMovie } from './_ytMovie.js';
export let kvMovie = {
	vSource: [],
	isYT: false,
	isVideo: false,
	init: function(){
		const ytVideo	= document.querySelector("#top_content .yt_kv");
		if( ytVideo ){
			kvMovie.isYT = true;
			ytMovie.init();
		}else{
			const wrapVideo = document.querySelector("#top_content .c-movie");
			if( wrapVideo ){
				kvMovie.isVideo = true;
				kvMovie.vSource[0] = wrapVideo.getAttribute("data-movie-sp");
				kvMovie.vSource[1] = wrapVideo.getAttribute("data-movie-pc");
			}
		}
	},
	resize: function( beforeW ){
		//console.log("kvMovie.resize", kvMovie.isVideo)
		if( kvMovie.isVideo ){
			const videoElement 	= document.getElementById('kv_video');
			const videoSource 	= document.getElementById('kv_video_source');
			
			function setVideoSource() {
				const width = window.innerWidth;
				let newSource;
				if (width <= 959) {
					newSource = kvMovie.vSource[0];
				} else if (width >= 960) {
					newSource = kvMovie.vSource[1];
				}
				if( width != beforeW ){
					//console.log(vSource, newSource);
					if (videoSource.src !== newSource) {
						videoSource.src = newSource;
						videoElement.load(); // 新しいソースを読み込む
						videoElement.pause();
						kvMovie.checkPlay();
					}
				}
				kvMovie.checkPlay();
			}
			setVideoSource();
		}else{
			//console.log("YouTube Movie再生")
			if( ytMovie.canPlay ){
				ytMovie.resize(beforeW);
			}
		}
	},
	checkPlay: function(){
		if( !kvMovie.isVideo ){ return }
		let path = location.pathname;
		//console.log(path);
		const videoElement 	= document.getElementById('kv_video');
		//console.log(path, videoElement.paused);
		if( path === "/" ){
			if( kvMovie.isVideo ){
				if( videoElement.paused ){
					videoElement.play();
				}
			}
		}else{
			if( kvMovie.isVideo ){
				if( !videoElement.paused ){
					videoElement.pause();
				}
			}
		}
	}
}